import { useMemo, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getHistory, getPlayerCareer, me } from '../api/portal';
import { ApiError } from '../api/client';

export function HistoryPage() {
  const profile = useQuery({ queryKey: ['portal-me'], queryFn: me });
  const [seasonId, setSeasonId] = useState('');
  const hist = useQuery({
    queryKey: ['portal-history', seasonId],
    queryFn: () => getHistory(seasonId || undefined),
  });
  const data = hist.data;
  const seasons = data?.seasons ?? [];
  const chosen = seasonId || data?.season_id || '';
  const [playerId, setPlayerId] = useState('');
  const career = useQuery({
    queryKey: ['portal-career', playerId],
    queryFn: () => getPlayerCareer(playerId),
    enabled: playerId.length > 20,
  });
  const center = useMemo(() => {
    const slug = profile.data?.public_slug;
    if (!slug) return '';
    return `http://127.0.0.1:8081/l/${slug}`;
  }, [profile.data?.public_slug]);

  return (
    <div>
      <div className="page-head">
        <div className="page-kicker">Sezona</div>
        <h1 className="page-title">Sezona unazad</h1>
        <p className="page-sub">
          Tabela tekuće i prošle sezone, pomeraj mesta, karijera igrača u ligi.
          {center ? <> Javni match center: <a className="text-white underline" href={center} target="_blank" rel="noreferrer">{center}</a></> : null}
        </p>
      </div>
      <div className="mb-4 max-w-md">
        <label className="label">Sezona</label>
        <select className="input" value={chosen} onChange={(e) => setSeasonId(e.target.value)}>
          {seasons.map((s) => (
            <option key={s.id} value={s.id}>{s.name} · {s.competition_code}</option>
          ))}
        </select>
      </div>
      {hist.isError && <div className="alert-bad mb-3">{hist.error instanceof ApiError ? hist.error.message : String(hist.error)}</div>}
      <div className="grid gap-4 lg:grid-cols-2">
        <div className="card p-4">
          <div className="mb-2 text-[11px] uppercase text-slate-500">{data?.standings?.season_name || 'Tabela'}</div>
          {(data?.standings?.rows ?? []).map((r) => (
            <div key={r.team_id} className="flex justify-between py-1 text-sm">
              <span className="text-white"><span className="mr-2 text-slate-500">{r.rank}.</span>{r.team_name}</span>
              <span className="tabular-nums text-slate-300">{r.points}b · {r.played}u</span>
            </div>
          ))}
          {(data?.standings?.rows ?? []).length === 0 && <div className="text-sm text-slate-500">Nema tabele.</div>}
        </div>
        <div className="card p-4">
          <div className="mb-2 text-[11px] uppercase text-slate-500">Naspram prošle sezone</div>
          {(data?.yoy ?? []).map((r) => (
            <div key={r.team_name} className="flex justify-between py-1 text-sm">
              <span className="text-white">{r.team_name}</span>
              <span className="tabular-nums text-slate-300">
                {r.rank}. {r.prev_rank != null ? `(bilo ${r.prev_rank}.)` : 'novo'}
                {r.rank_delta != null && r.rank_delta !== 0 ? ` · ${r.rank_delta > 0 ? '+' : ''}${r.rank_delta}` : ''}
              </span>
            </div>
          ))}
          {(data?.yoy ?? []).length === 0 && <div className="text-sm text-slate-500">Nema prethodne sezone za poređenje.</div>}
        </div>
      </div>
      <div className="card mt-4 p-4 max-w-xl">
        <div className="mb-2 text-[11px] uppercase text-slate-500">Karijera igrača</div>
        <input className="input mb-3" value={playerId} onChange={(e) => setPlayerId(e.target.value.trim())} placeholder="person UUID" />
        {career.data && (
          <>
            <div className="mb-2 text-white">{career.data.player}</div>
            {career.data.seasons.map((s) => (
              <div key={s.season} className="flex justify-between text-sm py-0.5">
                <span className="text-slate-300">{s.season} · {s.competition_code}</span>
                <span className="tabular-nums text-white">{s.goals} gol · {s.matches} ut</span>
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
}
